import React, { useState, useEffect } from "react";

const TermsModal = () => {
  const [isVisible, setIsVisible] = useState(false);

  const openModal = () => {
    setIsVisible(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsVisible(false);
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") closeModal();
    };
    window.addEventListener("keyup", handleEscape);
    return () => window.removeEventListener("keyup", handleEscape);
  }, []);

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    zIndex: 999,
  };

  const modalStyle = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#fff",
    padding: "2rem",
    maxWidth: "600px",
    width: "90%",
    borderRadius: "8px",
    zIndex: 1000,
    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.2)",
    overflowY: "auto",
    maxHeight: "80vh",
  };

  const closeButtonStyle = {
    marginTop: "1rem",
    backgroundColor: "#444",
    color: "#fff",
    border: "none",
    padding: "0.6rem 1.2rem",
    cursor: "pointer",
    borderRadius: "4px",
    fontSize: "1rem",
  };

  const openButtonStyle = {
  width: "120px",
  height: "120px",
  borderRadius: "50%",
  backgroundColor: "#9643aa",
  color: "#fff",
  border: "none",
  cursor: "pointer",
  fontSize: "1.2rem",
  position: "fixed",       // stays in place
  bottom: "20px",          // distance from bottom
  right: "20px",           // distance from right
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  zIndex: 1001,
};

  return (
    <div>
      <button style={openButtonStyle} onClick={openModal}  className="square-button">
        Read the Rules
      </button>

      {isVisible && (
        <>
          <div style={overlayStyle} onClick={closeModal}></div>
          <div style={modalStyle}>
            <p><strong>Tip Toe Grooming Limited</strong></p>
            <p><u>Disclaimer of Liability for Accidental Pet Damage</u></p>
            <p>
              Tip Toe Grooming Limited is dedicated to providing top-quality grooming
              services for your cherished pets. Despite our utmost care and attention,
              unforeseen incidents may occur during grooming, daycare and/or walking
              sessions. By utilising our services, you agree to the terms outlined below:
            </p>
            <p><strong>Assumption of Risk:</strong> You acknowledge that grooming
              procedures, while conducted with the highest standards of care, carry
              inherent risks for your pet. These may include minor cuts, scratches, or
              skin irritations.
            </p>
            <p><strong>Disclosure of Health Conditions:</strong> You must disclose any
              pre-existing health conditions, allergies, or sensitivities your pet may
              have. Failure to do so may lead to complications for which Tip Toe
              Grooming Limited will not be held liable.
            </p>
            <p><strong>Runaway Pets:</strong> While precautions are taken, there is a
              risk that a pet may escape during grooming. You acknowledge this risk and
              agree that Tip Toe Grooming Limited is not liable for escaped pets.
            </p>
            <p><strong>Emergency Care:</strong> If emergency care is needed, Tip Toe
              Grooming will try to contact you. If unreachable, you authorize us to seek
              care and accept responsibility for the cost.
            </p>
            <p><strong>Ongoing Consent:</strong> This consent form remains valid for all
              future visits, and you do not need to sign a new one each time.
            </p>
            <p><strong>Release of Liability:</strong> You release Tip Toe Grooming and
              its staff from liability for accidental damage, injuries, or escapes that
              may occur during grooming, daycare, or walking sessions.
            </p>
            <p>
              Please review and discuss any concerns with our staff. By continuing, you
              acknowledge and accept the terms outlined above.
            </p>
            <p><strong>Tip Toe Grooming Management</strong></p>

            <button style={closeButtonStyle} onClick={closeModal}>
              Close
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default TermsModal;
